import collecty from '@ellescript/collecty';

export class BaseCollection extends collecty.Collection {
    get links() {
        return this.iterable.links
    }

    // TODO: 🔴 Implementar sort en collecty
    sort() {
        let newCollection = this.clone();
        newCollection.set(this.toArray().sort((a, b) => a.localeCompare(b)));
        return newCollection
    }
}